module.exports = __webpack_public_path__ + "static/img/p4.3c458ef8.png";